<aside class="sidebar">
  <div class="sidebar__brand">
    <span class="sidebar__logo">🌙</span>
    <div>
      <strong>تقویم پریود</strong>
      <p>داشبورد مدیریت</p>
    </div>
  </div>

  <nav class="sidebar__nav">
    @for (item of navItems; track item.path) {
      <a [routerLink]="item.path" routerLinkActive="sidebar__link--active" class="sidebar__link">
        <span class="sidebar__icon">
          @switch (item.icon) {
            @case ('grid') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <rect x="3.5" y="3.5" width="7" height="7" rx="1.5" />
                <rect x="13.5" y="3.5" width="7" height="7" rx="1.5" />
                <rect x="3.5" y="13.5" width="7" height="7" rx="1.5" />
                <rect x="13.5" y="13.5" width="7" height="7" rx="1.5" />
              </svg>
            }
            @case ('users') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <circle cx="9" cy="8" r="3" />
                <path d="M3.5 19c0.8-3 3-4.6 5.5-4.6s4.7 1.6 5.5 4.6" />
                <circle cx="17" cy="8.5" r="2.2" />
                <path d="M15.2 14.6c2 0.1 3.7 1.5 4.3 3.9" />
              </svg>
            }
            @case ('bell') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <path d="M12 3.5c-2.5 0-4.5 2-4.5 4.5v3.5l-1.5 3h12l-1.5-3V8c0-2.5-2-4.5-4.5-4.5Z" stroke-linejoin="round" />
                <path d="M9.5 17.5a2.5 2.5 0 0 0 5 0" />
              </svg>
            }
          }
        </span>
        <span>{{ item.label }}</span>
      </a>
    }
  </nav>

  <div class="sidebar__footer">
    <p class="sidebar__admin-name">{{ adminName }}</p>
    <button class="sidebar__logout" (click)="logout()">خروج</button>
  </div>
</aside>
